import { HealthcareProviderRegisterBookNumber } from '@dreryk/healthcare-provider-register-book-number-api';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, HealthcareProviderRegisterBookNumberInput } from '@dreryk/react-components';

import { healthcareProviderTranslationKeys } from '../../translations';

type RegisterBookNumberInputProps = FieldControllerProps<
   'registerBookNumber',
   HealthcareProviderRegisterBookNumber | null
> &
   ClassNameProp;

export const RegisterBookNumberInput = (props: RegisterBookNumberInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <HealthcareProviderRegisterBookNumberInput
         testId={props.name}
         label={healthcareProviderTranslationKeys.registerBookNumber}
         controller={controller}
         className={props.className}
      />
   );
};
